import {Injectable} from '@angular/core';

@Injectable()
export class ScriptLoader {

  constructor() {
  }

  loadJS(url, implementationCode, location) {
    //url is URL of external file, implementationCode is the code
    //to be called from the file, location is the location to
    //insert the <script> element

    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;

    location.appendChild(scriptTag);
  };


}



// WEBPACK FOOTER //
// ./src/providers/script-loader/script-loader.ts